// extracted by mini-css-extract-plugin
export var quantityInput = "_oq-0";